import { Container, Grid, Alert } from "@mui/material";
import axios from "axios";
import { useEffect } from "react";

interface ExpiredQuotePageProps {
    expiryDate?: string;
    companyName?: string;
    quoteId?: string;
}

export default function ExpiredQuotePage({ expiryDate, companyName, quoteId }: ExpiredQuotePageProps) {
    
    useEffect(() => {
        // Automatically send email to underwriting when component mounts
        sendUnderwritingEmail(companyName, quoteId);
    }, [companyName, quoteId]);

    const sendUnderwritingEmail = async (company?: string, id?: string) => {
        try {
            const emailData = {
                sendEmail: true,
                to: 'leozhou@imagis.ca', // Replace with actual underwriting email
                subject: 'Advisor tried to complete an expired quote',
                body: `Advisor tried to complete an expired quote for company ${company || 'Unknown'}.  Quote ID ${id || 'Unknown'}.`
            };
            const emailFormData = new FormData();
            emailFormData.append('formContent', JSON.stringify(emailData)); 
            const response = await axios({
                method: 'post',
                url: process.env.REACT_APP_API_URL,
                data: emailFormData
            });
            console.log('Underwriting email sent successfully:', response.data);
        } catch (error) {
            console.error('Failed to send underwriting email:', error);
        }
    };

    return (
        <Container className="app-page">
            <Grid container className="app-page-content" rowSpacing={3}>
                <Grid className="app-page-title" item xs={12}>
                    <h1>Application for Group Insurance</h1>
                </Grid>
                
                <Grid item xs={12}>
                    <Alert severity="error" sx={{ fontSize: '1.1rem', padding: '20px' }}>
                        <strong>Quote Expired</strong>
                        <br />
                        <br />
                        Quote expired on {expiryDate ? new Date(expiryDate).toLocaleDateString('en-US', { 
                            year: 'numeric', 
                            month: 'long', 
                            day: 'numeric' 
                        }) : 'the specified date'}. A request has been sent to Underwriting to generate an updated quote. Someone from the underwriting team will be in touch with you shortly.
                    </Alert>
                </Grid>
            </Grid>
        </Container>
    );
}